export const routePathConfig = {
  landing: '/',
  login: '/login',
  error: '/error',
  grantConsent: '/grantConsent',
} as const;

export type RoutePath = (typeof routePathConfig)[keyof typeof routePathConfig];
